var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"text-center"},[_vm._v("\n    404！NOT FOUND！\n  ")]),_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('h-button',{attrs:{"type":"primary"}},[_vm._v("首页")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }